import { createStore } from 'dashboard/store/storeFactory';
import OperatingProceduresAPI from 'dashboard/api/operatingProcedures';

export const useOperatingProceduresStore = createStore({
  name: 'OperatingProcedure',
  type: 'pinia',
  API: OperatingProceduresAPI,
  getters: {
    getById: state => id => state.records.find(sop => sop.id === Number(id)),
  },
});
